import { render, staticRenderFns } from "./CreditorListStatementDetail.vue?vue&type=template&id=ffba88c2&scoped=true"
import script from "./CreditorListStatementDetail.vue?vue&type=script&lang=js"
export * from "./CreditorListStatementDetail.vue?vue&type=script&lang=js"
import style0 from "./CreditorListStatementDetail.vue?vue&type=style&index=0&id=ffba88c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffba88c2",
  null
  
)

export default component.exports